﻿import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import { User } from '../_models';
import { config } from '../../assets/config';

@Injectable()
export class UserService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<User[]>(`${config.apiUrl}/users`);
    }

    getById(id: number) {
        return this.http.get(`${config.apiUrl}/users/` + id);
    }

    register(user: any) {
        return this.http.post(`${config.apiUrl}/users/`, user, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    login(email: string, password: string) {
        const data = {
            email,
            password,
        }

        return this.http.post(`${config.apiUrl}/login`, data, );
    }

    update(user: User) {
        return this.http.put(`${config.apiUrl}/users/` + user.id, user);
    }

    delete(id: number) {
        return this.http.delete(`${config.apiUrl}/users/` + id);
    }
}
